<template>
  <div class="basic_flod_text">
    <!-- 折叠文件夹名字 -->
    <div class="tooptipPart all_tooptipPart" >
        <my_edit_btn
          :module="module"
          :title="$t('widgets_basic_article_classification_index_336')"
        ></my_edit_btn>
        <my_edit_btn
          :module="module"
          tabName="animation"
          :title="$t('widgets_basic_article_classification_edit_330')"
          v-if="isPc"
        ></my_edit_btn>
       <!--  <my_link_btn
          :module="module"
          title="设置链接"
        ></my_link_btn> -->
        <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
          :title="$t('widgets_basic_article_list_index_414')"
        ></my_close_btn>
      
    </div>
    <!-- 标题栏是公共的部分 -->
     <my_title_index :title="infor.title"></my_title_index>
    <div class="basic_flod_text_content" :style="{
      ...backgroundStyle,
      '--titleFontColor_PC':titleFontColor_PC,
      '--titleFontSeColor_PC':titleFontSeColor_PC,
      '--titleFontColor_MB':titleFontColor_MB,
      '--titleFontSeColor_MB':titleFontSeColor_MB,
    }">
    <!-- '--contentFontColor_PC': contentFontColor_PC,
      '--contentFontSeColor_PC': contentFontSeColor_PC,
      '--contentFontColor_MB': contentFontColor_MB,
      '--contentFontSeColor_MB': contentFontSeColor_MB -->
      <div class="flod_text_title" @click.stop="contentShow">
        <!-- 图标图片 -->
        <img :src="listArr.icon_img[listArr.icon_img.radio_val].img" alt="" class="title-icon" v-if="listArr.icon_show">
        <span class="title-text title-text-pc" :style="{...titleFontStyle_PC}">{{ getLang(listArr.title) }}</span>
        <span class="title-text title-text-mb" :style="{...titleFontStyle_MB}">{{ getLang(listArr.title) }}</span>
      </div>
      
      <div class="flod_text_content" :id="`flod_text_content${editID}`"  :class="[
        pcWidgetsInfor.show_type == 'default' ? 'flod_content_height_auto': 'flod_content_height_0',
        listArr.icon_show ? 'flod_text_content_padding': ''
      ]" >
      <!-- :style="{...contentFontStyle_PC}" :style="{...contentFontStyle_MB}" -->
        <div class="content-text"  v-html="listArr.content"></div>
       
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

export default {
  name: 'basic_flod_text',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {}
  },
  computed: {
    module_infor () {
      return this.module.data[this.$store.state.app.view_pattern + '_infor'];
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    editID() {
     return this.module.widgets_id
    },
    infor() {
      return this.module.data[
      this.$store.state.app.view_pattern + "_widgets_infor"
        ];
    },
    pcWidgetsInfor() {
       return this.module.data.pc_widgets_infor
    },
    mbWidgetsInfor() {
       return this.module.data.mb_widgets_infor
    },
    listArr(){
      return this.module.data.listArr
    },
    backgroundStyle() { // 背景颜色 pc 和手机一样
      let background = this.pcWidgetsInfor.background
      if (background.radio_val === "hidden") {
        return {
          background: "transparent"
        };
      }
      return {
        backgroundColor: background[
          background.radio_val
        ].color,
        backgroundImage:
          "url(" +
          (background[
            background.radio_val
          ].img || "") +
          ")",
        backgroundSize: background[
          background.radio_val
        ].background_size,
        backgroundRepeat:background[
          background.radio_val
        ].background_repeat,
        backgroundPosition: background[
          background.radio_val
        ].background_position
      };
    },
    titleFontStyle_PC() { // PC标题字体样式
      let fontStyle = {};
      let infor = this.pcWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      fontStyle.fontSize = font.fontSize + "px";
      fontStyle.fontFamily = font.fontFamily;
      fontStyle.fontStyle = font.fsItalics;
      fontStyle.fontWeight = font.fsWeight;
      //text-decoration
      fontStyle.textDecoration= font.fontUnderline;
      if (font.pattern == "linear_gradient") {
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage =
          "linear-gradient(" +
          font.linear_gradient.deg +
          "deg," +
          font.linear_gradient.start_color +
          font.linear_gradient.start_pointer +
          "%," +
          font.linear_gradient.end_color +
          font.linear_gradient.end_pointer +
          "%)";
      } else {
        // fontStyle.color = font.fontColor;
      }

      return fontStyle;
    },
    titleFontStyle_MB() { // MB标题字体样式
      let fontStyle = {};
      let infor = this.mbWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      fontStyle.fontSize = font.fontSize + "px";
      fontStyle.fontFamily = font.fontFamily;
      fontStyle.fontStyle = font.fsItalics;
      fontStyle.fontWeight = font.fsWeight;
      fontStyle.textDecoration= font.fontUnderline;
      if (font.pattern == "linear_gradient") {
        fontStyle.webkitBackgroundClip = "text";
        fontStyle.webkitTextFillColor = "transparent";
        fontStyle.color = "";
        fontStyle.backgroundImage =
          "linear-gradient(" +
          font.linear_gradient.deg +
          "deg," +
          font.linear_gradient.start_color +
          font.linear_gradient.start_pointer +
          "%," +
          font.linear_gradient.end_color +
          font.linear_gradient.end_pointer +
          "%)";
      } else {
        // fontStyle.color = font.fontColor;
      }

      return fontStyle;
    },
    titleFontColor_PC() { // 标题颜色 PC端的字体颜色
      let infor = this.pcWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      return font.fontColor;
    },
    titleFontColor_MB() { // 标题颜色 手机端的字体颜色
      let infor = this.mbWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      return font.fontColor;
    },
    titleFontSeColor_PC(){ // 标题选中颜色
      let infor = this.pcWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      return font.selectColor;
    },
    titleFontSeColor_MB(){ // 标题选中颜色
     let infor = this.mbWidgetsInfor
      let font = infor.title_font[
        infor.title_font.radio_val
      ];
      return font.selectColor;
    },

  },
  mounted(){
  },
  methods: {
    contentShow(){
      let dom = document.querySelector(`#flod_text_content${this.editID}`);
      let height = dom.querySelector('.content-text').offsetHeight ? dom.querySelector('.content-text').offsetHeight : dom.querySelector('.content-text').offsetHeight
      if(dom.classList.contains('flod_content_height_0')){
        dom.classList.add('flod_content_height_auto')
        dom.classList.remove('flod_content_height_0')
        dom.style.height= `${height}px`
      }else {
        dom.classList.add('flod_content_height_0')
        dom.classList.remove('flod_content_height_auto')
        dom.style.height= `0px`
      }
    }
  },
  watch: {
    'pcWidgetsInfor.show_type'(){ // 默认展开和点击展开 对class 和height 进行处理
      // this.contentShow()
      let dom = document.querySelector(`#flod_text_content${this.editID}`);
      let height = dom.querySelector('.content-text').offsetHeight ? dom.querySelector('.content-text').offsetHeight : dom.querySelector('.content-text').offsetHeight
      if(this.pcWidgetsInfor.show_type == 'default') { // 默认展开
        dom.classList.add('flod_content_height_auto')
        dom.classList.contains('flod_content_height_0')&&dom.classList.remove('flod_content_height_0')
        dom.style.height= `${height}px`
      } else{ // 点击展开
        dom.classList.add('flod_content_height_0')
        dom.classList.contains('flod_content_height_auto')&&dom.classList.remove('flod_content_height_auto')
        dom.style.height= `0px`
      }
    },
    'listArr.content'(){
      this.$nextTick(()=> {
        let dom = document.querySelector(`#flod_text_content${this.editID}`);
        let height = dom.querySelector('.content-text').offsetHeight;
        console.log('uuu', height)
        if(dom.classList.contains('flod_content_height_auto')) {
          dom.style.height= `${height}px`
        }
      })
    },
    'module_infor.marginRight'() {
      this.$nextTick(()=> {
        let dom = document.querySelector(`#flod_text_content${this.editID}`);
        let height = dom.querySelector('.content-text').offsetHeight;
        console.log('uuu', height)
        if(dom.classList.contains('flod_content_height_auto')) {
          dom.style.height= `${height}px`
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.basic_flod_text{
  .basic_flod_text_content{
    padding-left: 20px;
    box-sizing: border-box;
    .flod_text_title{
      display: flex;
      align-items: center;
      // color:var(--titleFontColor);
      .title-icon{
        width:20px;
        height:20px;
        margin-right:5px;
      }
      &:hover{
        .title-text{
          background-image: none !important;
        }
        // color:var(--titleFontSeColor);
      }
    }
    .flod_text_content{
      word-wrap:break-word;
      // color:var(--contentFontColor);
      transition: all 1s;
      overflow: hidden;
      &:hover{
        .content-text{
          background-image: none !important;
        }
        // color:var(--contentFontSeColor);
      }
      &.flod_text_content_padding{
        padding-left:25px;
      }
      &.flod_content_height_0{
        height:0,
      }
      &.flod_content_height_auto{
        height:auto;
      }
    }
  }
}
.pc_pattern .basic_flod_text .basic_flod_text_content{
  .flod_text_title {
    .title-text{
      color:var(--titleFontColor_PC);
    }
    
    &:hover{
      .title-text{
        -webkit-text-fill-color:  var(--titleFontSeColor_P) !important;
        color:var(--titleFontSeColor_PC);
      }
     
    }
    .title-text-mb{
      display:none;
     
    }
  }
  
}
.mb_pattern .basic_flod_text .basic_flod_text_content{
  .flod_text_title{
    color:var(--titleFontColor_MB);
    &:hover{
      .title-text{
        -webkit-text-fill-color:  var(--titleFontSeColor_MB) !important;
        color:var(--titleFontSeColor_MB);
      }
     
    }
    .title-text-pc{
      display:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_flod_text/index.vue